<!DOCTYPE html>
<!--
	TODO:
		Verify FS Set
			- Upload PDF
			- App will disect PDF per page (as image)
			- Upload to storage images based on storageRef
				- create storage reference first before calling fileAPI.put(...)
			- Create object for the FS Set that will be created in the FinancialStatementSet/ ref
				- createdDate
				- uploadedBy
				- pages[] ID
					- pageNum
					- storageRef
			- Storage FCF will have hook, to add qr watermark
				- qr code is based on [FinancialStatementSet ID]/[Page ID]
				- composite image will be final and stored in Cloud Storage
-->
<template>
	<main id="main-content" class="container py-4">
		<verify-fs-set/>
	</main>
</template>
<style lang="scss" scoped>
</style>
<script>
	import VerifyFsSet from "@/components/verify-fs-set";
	
	export default {
		methods: {
		},
		components: {'verify-fs-set': VerifyFsSet},
		data() {
			return {
			}
		},
	}
</script>

